import React from 'react';
import PropTypes from 'prop-types';

import classnames from 'classnames';
import i18n from 'i18next';

import { Button, ButtonGroup } from 'uikit/buttons';
import { Loading } from 'uikit/loaders';

import FormContainer from '../containers/formContainer';

import styles from '../styles/modificationTrackingForm.module.scss';

const ModificationTrackingForm = ({
  className = '',
  formPrepend = null,
  isDisabled = false,
  isModelModified = false,
  isSaveButtonDisabled = true,
  isSubmittingForm = false,
  model = {},
  modifiedClassName = '',
  onCancelClick = () => {},
  onFormLoad = () => {},
  onFormUpdate = () => {},
  onSaveClick = () => {},
  schema = {},
}) => (
  <div
    className={classnames(styles.element, className, {
      [styles.isModelModified]: isModelModified,
      [modifiedClassName]: isModelModified,
    })}
  >
    <div className={styles.formContainer}>
      {formPrepend && <div className={styles.formPrepend}>{formPrepend}</div>}
      <div className={styles.form}>
        <FormContainer
          model={model}
          schema={schema}
          onLoad={onFormLoad}
          onUpdate={onFormUpdate}
          isDisabled={isDisabled}
        />
      </div>
    </div>
    {isModelModified && (
      <ButtonGroup>
        <Button
          text={i18n.t('save-changes')}
          color="brand"
          onClick={onSaveClick}
          isDisabled={isSaveButtonDisabled || isSubmittingForm || isDisabled}
        />
        <Button
          text={i18n.t('cancel')}
          variant="ghost"
          onClick={onCancelClick}
          isDisabled={isDisabled}
        />
        {isSubmittingForm && <Loading />}
      </ButtonGroup>
    )}
  </div>
);

ModificationTrackingForm.propTypes = {
  className: PropTypes.string,
  formPrepend: PropTypes.node,
  isDisabled: PropTypes.bool,
  isModelModified: PropTypes.bool,
  isSaveButtonDisabled: PropTypes.bool,
  isSubmittingForm: PropTypes.bool,
  model: PropTypes.shape({}),
  modifiedClassName: PropTypes.string,
  onCancelClick: PropTypes.func,
  onFormLoad: PropTypes.func,
  onFormUpdate: PropTypes.func,
  onSaveClick: PropTypes.func,
  schema: PropTypes.shape({}),
};

export default React.memo(ModificationTrackingForm);
